'use client';

import type { MouseEvent } from 'react';
import { EmptyState } from '@yanolja-rnd/nol-design-system';
import { useImpressionLog } from '@/app/_shared/hooks/use-impression-log';

export interface OmBannerProps {
  title: string;
  subTitle?: string | null;
  buttonText?: string;
  logMeta?: Record<string, unknown>;
  onClick?: () => void;
  onImpression?: () => void;
}

export const OmBanner = ({ title, subTitle, buttonText, onClick, onImpression }: OmBannerProps) => {
  const ref = useImpressionLog(onImpression);

  const handleItemClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onClick?.();
  };

  return (
    <div ref={ref} className="flex w-full justify-center">
      <EmptyState
        title={title}
        description={subTitle || ''}
        buttons={[{ content: buttonText || '', onClick: handleItemClick }]}
        pcType="pcLegacySize"
      />
    </div>
  );
};
